// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/component/" + chunkId + "." + "c56ac75a6c420bb6" + ".js";
};